export default "__VITE_ASSET__1d73ef5a__"